import { Reveal } from "./Reveal";

const STATS = [
  { value: "24/7", label: "Coverage & rapid response" },
  { value: "100%", label: "Indigenous-owned & operated" },
  { value: "5", label: "Specialized security divisions" },
  { value: "#1", label: "Priority: your safety" },
];

export const Stats = () => (
  <section data-testid="stats-section" className="relative py-16 md:py-20 bg-black border-y border-white/10">
    <div className="mx-auto max-w-7xl px-5 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.08}>
          <div data-testid={`stat-${i}`} className="text-left">
            <div className="font-display text-5xl md:text-6xl tracking-tight text-[color:var(--primary-text)] leading-none">
              {s.value}
            </div>
            <div className="mt-3 text-sm text-secondary max-w-[160px]">{s.label}</div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
